export class NotesConstants {
  static filterAll = 'all';
}
